<template>

  <div class="row">
    <div class="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3">
      <form method="#" action="#">

        <div v-if="resetPasswordToken">
          <update-password-card :token="resetPasswordToken" @saved="$router.push('/')" @failed="state = 'FORGOT'" />
        </div>

        <div v-else class="card" data-background="color" data-color="blue">
          <div class="card-header">
            <h3 class="card-title">Reset password</h3>
          </div>
          <div class="card-content">
            <div class="form-group">
              <label>Email address / Username</label>
              <input v-model="username" type="email" placeholder="Enter email" class="form-control input-no-border">
            </div>
          </div>
          <div class="card-footer text-center">
            <button @click.prevent="reset" type="submit" class="btn btn-fill btn-wd ">
              <i v-if="working" class="fa fa-cog fa-spin" aria-hidden="true"></i>
              <span v-else>Reset</span>
            </button>
            
            <div class="forgot">
              <router-link to="/login">Cancel</router-link>
            </div>
          </div>
        </div>
      
      </form>
    </div>
  </div>
          
</template>
<script>
  import UpdatePasswordCard from 'src/views/Account/components/UpdatePasswordCard'
  
  export default {
    components: {
      UpdatePasswordCard
    },
    props: {
      resetToken: String
    },
    data () {
      return {
        username: null,
        resetPasswordToken: null,
        working: false
      }
    },
    created () {
      this.resetPasswordToken = this.$route.query.token ? this.$route.query.token : this.resetToken;
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      reset () {
        this.working = true
        this.error = null
        this.$api.resetPassword(this.username)
          .then(response => {
            this.$snotify.success("If registered, instructions on how to reset your password have been sent, please check your inbox.", "Success", {
              timeout: 7500
            })
            this.$router.push('/login')
            this.working = false
          })
          .catch(error => {
            console.log(error)
            this.working = false
          })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
